export default "__VITE_ASSET__CP0AaEzX__"